import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../NewAuthProvider';

const useSetupTotp = (): { code: string; error: Error | null } => {
  const [totpCode, setTOTPCode] = useState('');
  const [error, setError] = useState<null | Error>(null);
  const { setupTOTP } = useAuth();
  const effectCalled = useRef(false);

  useEffect(() => {
    if (effectCalled.current) {
      return;
    }

    const getToken = async (): Promise<void> => {
      try {
        const result = await setupTOTP();
        setTOTPCode(result.sharedSecret || '');
      } catch (e) {
        setError(e as Error);
        effectCalled.current = false;
      }
    };

    // react strict mode hack
    effectCalled.current = true;
    getToken();
  }, [setupTOTP]);

  return { code: totpCode, error: error };
};

export default useSetupTotp;
